import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

// Campo de senha com botao de olho para mostrar/ocultar o que foi digitado.
// Mesmo padrao visual do login (AccessGateway). `inputComponent` permite usar
// o Input do design system no lugar do <input> nativo.
export function PasswordInput({
  className = '',
  wrapperClassName = '',
  toggleClassName = 'border-cyan-500/20 text-cyan-200 hover:bg-cyan-500/10 hover:text-cyan-100',
  inputComponent: InputComponent = 'input',
  ...props
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`relative ${wrapperClassName}`}>
      <InputComponent {...props} type={visible ? 'text' : 'password'} className={`${className} pr-12`} />
      <button
        type="button"
        aria-label={visible ? 'Ocultar senha' : 'Visualizar senha'}
        title={visible ? 'Ocultar senha' : 'Visualizar senha'}
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => setVisible((current) => !current)}
        className={`absolute right-2 top-1/2 flex h-8 w-8 -translate-y-1/2 cursor-pointer items-center justify-center rounded border transition-colors ${toggleClassName}`}
      >
        {visible ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
}

export default PasswordInput;
